'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$7() {
  this.bmc = null;
  this.bma = null;
  this.bmb = false;
  this.bm8 = null;
  this.bm9 = false;
  this.bmd = false;
  this.bme = false;
  this.bmc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$7 as $c_Lpresto_PrestoRouter$$anon$7 };
$p = $c_Lpresto_PrestoRouter$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$7;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$7() {
}
export { $h_Lpresto_PrestoRouter$$anon$7 as $h_Lpresto_PrestoRouter$$anon$7 };
$h_Lpresto_PrestoRouter$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bmc;
});
$p.t = (function() {
  if ((!this.bmb)) {
    this.bma = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmb = true;
  }
  return this.bma;
});
$p.ae = (function() {
  if ((!this.bm9)) {
    this.bm8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bm9 = true;
  }
  return this.bm8;
});
$p.w = (function() {
  if ((!this.bme)) {
    this.bmd = false;
    this.bme = true;
  }
  return this.bmd;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$7, "presto.PrestoRouter$$anon$7", ({
  OC: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$7 as $d_Lpresto_PrestoRouter$$anon$7 };
//# sourceMappingURL=presto.-Presto-Router$$anon$7.js.map
